/* tslint:disable */
/* eslint-disable */
/**
 * documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ManualWithPassword,
  RefreshAccessKey200Response,
  SetConfigRequest,
  Sort200ResponseInner,
  TableQuery,
  TableResultManual,
} from '../models/index';

export interface ManualPrivateApiConfigRequest {
    tenant: string;
    path: string;
}

export interface ManualPrivateApiCreateRequest {
    tenant: string;
    folderPath: string;
    news?: boolean;
}

export interface ManualPrivateApiCreateFromDocumentRequest {
    tenant: string;
    filePath: string;
}

export interface ManualPrivateApiOverviewTableRequest {
    tenant: string;
    tableQuery: TableQuery;
}

export interface ManualPrivateApiRefreshAccessKeyRequest {
    tenant: string;
    path: string;
}

export interface ManualPrivateApiSetActiveRequest {
    tenant: string;
    path: string;
    active: boolean;
}

export interface ManualPrivateApiSetConfigOperationRequest {
    tenant: string;
    path: string;
    setConfigRequest: SetConfigRequest;
}

export interface ManualPrivateApiSetPersistRequest {
    tenant: string;
    path: string;
    persist: boolean;
}

export interface ManualPrivateApiSortRequest {
    tenant: string;
    path: string;
}

/**
 * 
 */
export class ManualPrivateApi extends runtime.BaseAPI {

    /**
     */
    async configRaw(requestParameters: ManualPrivateApiConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ManualWithPassword>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling config().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling config().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/manual/config`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async config(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ManualWithPassword> {
        const response = await this.configRaw({ tenant: tenant, path: path }, initOverrides);
        return await response.value();
    }

    /**
     */
    async createRaw(requestParameters: ManualPrivateApiCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling create().'
            );
        }

        if (requestParameters['folderPath'] == null) {
            throw new runtime.RequiredError(
                'folderPath',
                'Required parameter "folderPath" was null or undefined when calling create().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['folderPath'] != null) {
            queryParameters['folderPath'] = requestParameters['folderPath'];
        }

        if (requestParameters['news'] != null) {
            queryParameters['news'] = requestParameters['news'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/manual/create`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async create(tenant: string, folderPath: string, news?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createRaw({ tenant: tenant, folderPath: folderPath, news: news }, initOverrides);
    }

    /**
     */
    async createFromDocumentRaw(requestParameters: ManualPrivateApiCreateFromDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling createFromDocument().'
            );
        }

        if (requestParameters['filePath'] == null) {
            throw new runtime.RequiredError(
                'filePath',
                'Required parameter "filePath" was null or undefined when calling createFromDocument().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filePath'] != null) {
            queryParameters['filePath'] = requestParameters['filePath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/manual/create/existingDoc`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createFromDocument(tenant: string, filePath: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createFromDocumentRaw({ tenant: tenant, filePath: filePath }, initOverrides);
    }

    /**
     */
    async overviewTableRaw(requestParameters: ManualPrivateApiOverviewTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TableResultManual>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling overviewTable().'
            );
        }

        if (requestParameters['tableQuery'] == null) {
            throw new runtime.RequiredError(
                'tableQuery',
                'Required parameter "tableQuery" was null or undefined when calling overviewTable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/manual/table/overview`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['tableQuery'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async overviewTable(tenant: string, tableQuery: TableQuery, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TableResultManual> {
        const response = await this.overviewTableRaw({ tenant: tenant, tableQuery: tableQuery }, initOverrides);
        return await response.value();
    }

    /**
     */
    async refreshAccessKeyRaw(requestParameters: ManualPrivateApiRefreshAccessKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RefreshAccessKey200Response>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling refreshAccessKey().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling refreshAccessKey().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/manual/refreshAccessKey`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async refreshAccessKey(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RefreshAccessKey200Response> {
        const response = await this.refreshAccessKeyRaw({ tenant: tenant, path: path }, initOverrides);
        return await response.value();
    }

    /**
     */
    async setActiveRaw(requestParameters: ManualPrivateApiSetActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling setActive().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling setActive().'
            );
        }

        if (requestParameters['active'] == null) {
            throw new runtime.RequiredError(
                'active',
                'Required parameter "active" was null or undefined when calling setActive().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/manual/setActive`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async setActive(tenant: string, path: string, active: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.setActiveRaw({ tenant: tenant, path: path, active: active }, initOverrides);
        return await response.value();
    }

    /**
     */
    async setConfigRaw(requestParameters: ManualPrivateApiSetConfigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling setConfig().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling setConfig().'
            );
        }

        if (requestParameters['setConfigRequest'] == null) {
            throw new runtime.RequiredError(
                'setConfigRequest',
                'Required parameter "setConfigRequest" was null or undefined when calling setConfig().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/manual/setConfig`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['setConfigRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setConfig(tenant: string, path: string, setConfigRequest: SetConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setConfigRaw({ tenant: tenant, path: path, setConfigRequest: setConfigRequest }, initOverrides);
    }

    /**
     */
    async setPersistRaw(requestParameters: ManualPrivateApiSetPersistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling setPersist().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling setPersist().'
            );
        }

        if (requestParameters['persist'] == null) {
            throw new runtime.RequiredError(
                'persist',
                'Required parameter "persist" was null or undefined when calling setPersist().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        if (requestParameters['persist'] != null) {
            queryParameters['persist'] = requestParameters['persist'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/manual/setPersist`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async setPersist(tenant: string, path: string, persist: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.setPersistRaw({ tenant: tenant, path: path, persist: persist }, initOverrides);
        return await response.value();
    }

    /**
     */
    async sortRaw(requestParameters: ManualPrivateApiSortRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Sort200ResponseInner>>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling sort().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling sort().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/manual/sort`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async sort(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Sort200ResponseInner>> {
        const response = await this.sortRaw({ tenant: tenant, path: path }, initOverrides);
        return await response.value();
    }

}
